import React from 'react';
import starImg from '../../img/star_icon.png';

const RewardInfo = ({ rewardText, classes }) => (
  <div className={classes.rewardwrp}>
    <img src={starImg} className={classes.rewardstar} alt="reward star icon" />
    <span className={classes.rewardsText}>{rewardText || 'Rewards'}</span>
  </div>
);

export default RewardInfo;
